import React from "react";
import { Link } from "react-router-dom";
import { ArrowUpLeft } from "lucide-react";
import { cn } from "../../lib/utils";

const QuickActionButton = ({
  to,
  onClick,
  icon: Icon,
  label,
  description = "",
  tone = "primary",
  className = "",
}) => {
  const tones = {
    primary:
      "border-primary-200 bg-primary-50 text-primary-800 hover:bg-primary-100 dark:border-primary-900/60 dark:bg-primary-950/30 dark:text-primary-200 dark:hover:bg-primary-950/60",
    neutral:
      "border-neutral-200 bg-white text-neutral-800 hover:bg-neutral-50 dark:border-neutral-800 dark:bg-neutral-900 dark:text-neutral-100 dark:hover:bg-neutral-800",
    success:
      "border-success-200 bg-success-50 text-success-800 hover:bg-success-100 dark:border-success-900/60 dark:bg-success-950/30 dark:text-success-200",
    warning:
      "border-warning-200 bg-warning-50 text-warning-900 hover:bg-warning-100 dark:border-warning-900/60 dark:bg-warning-950/30 dark:text-warning-200",
  };
  const content = (
    <>
      {Icon && (
        <span className="inline-flex h-9 w-9 flex-shrink-0 items-center justify-center rounded-lg bg-white/70 ring-1 ring-inset ring-black/5 dark:bg-white/10">
          <Icon size={18} aria-hidden="true" />
        </span>
      )}
      <span className="min-w-0 flex-1 text-start">
        <span className="block text-sm font-semibold">{label}</span>
        {description && (
          <span className="mt-0.5 block truncate text-xs opacity-75">
            {description}
          </span>
        )}
      </span>
      <ArrowUpLeft size={15} className="opacity-60" aria-hidden="true" />
    </>
  );
  const classes = cn(
    "group inline-flex min-h-14 items-center gap-3 rounded-xl border px-3 py-2 text-sm shadow-sm transition focus:outline-none focus:ring-2 focus:ring-primary-500/40",
    tones[tone] || tones.primary,
    className,
  );
  return to ? (
    <Link to={to} className={classes}>
      {content}
    </Link>
  ) : (
    <button type="button" onClick={onClick} className={classes}>
      {content}
    </button>
  );
};

export default QuickActionButton;
